<template lang="pug">
  div(:class="[$style.breadCrumb]" class="flex flex-wrap items-center")
    template(
      v-show="block.innerBlocks.length"
      v-for="(innerBlock, key) in block.innerBlocks"
    )
      Block(
        v-if="isBreadcrumb(key)"
        :class="[$style.breadcrumbLink]"
        :key="`breadcrumb${key}`"
        :block="innerBlock")
      span(
        v-else
        :class="[$style.breadcrumbIcon, 'flex']"
      )
        Icon(
          name="i:chevron-right-1"
          :size="12"
        )
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "DIYBreadCrumb",
  props: {
    block: {
      required: true,
      type: Object as () => Block
    }
  },
  methods: {
    isBreadcrumb(key: number) {
      return key === 0 || key % 2 === 0
    }
  }
})
</script>

<style lang="css" module>
:global(.diy-breadcrumbs) {
  @apply relative z-[1];
  > :global(.content) {
    @apply pt-ds-md pb-0 lg:-mb-ds-xl;
  }
}

.breadCrumb {
  :global(.av-paragraph) {
    @apply text-rebrandXs m-0 leading-normal break-words;
  }

  .breadcrumbLink {
    @apply text-anyvan-grey-medium; /* current page title */
    a {
      @apply text-gray-550;
    }
  }

  .breadcrumbIcon {
    @apply px-ds-xxs;
    svg {
      @apply fill-gray-550;
    }
  }
}
</style>
